<template>
  <el-tabs type="border-card" v-model="activeName">
    <el-tab-pane label="待办事项" name="1">
      <div class="el-icon-warning-outline">条件查询</div>
      <div class="condition-css">
        <el-form ref="form" :model="form" >
          <span>查询日期：</span>
          <el-date-picker
            v-model="form.startDateStr"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" size="mini" icon="el-icon-search" style="margin-left: 20px" @click="querySubmit">搜索</el-button>
        </el-form>
      </div>
      <div class="el-icon-warning-outline">待办事项</div>
      <div class="box-css">
        <div class="box-other box-lite">
          待确认：
          <el-link href="/order/list"  type="danger" v-if="noOver.confirmCount>0" target="_blank">{{noOver.confirmCount}}</el-link>
          <span v-else>{{noOver.confirmCount}}</span>
        </div>
        <div class="box-other box-lite">
          待审核：
          <el-link href="/order/audit"  type="danger" v-if="noOver.applyCount>0" target="_blank">{{noOver.applyCount}}</el-link>
          <span v-else>{{noOver.applyCount}}</span>
        </div>
        <div class="box-other box-lite">
          待发货：
          <el-link href="/order/send" type="danger" v-if="noOver.sendCount>0" target="_blank">{{noOver.sendCount}}</el-link>
          <span v-else>{{noOver.sendCount}}</span>
        </div>
        <div class="box-other box-lite">
          待退款：{{noOver.refundCount}}
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
  data() {
    return {
      data: [],
      saleTimeList: [],
      saleAmountList: [],
      activeName: "1",
      showKey: true,
      noOver: {
        confirmCount: 0,
        applyCount: 0,
        sendCount: 0,
        refundCount: 0 
      },
      form: {
        token: this.user.getToken(),
        startDateStr: [],
        groupCt: 1
      },
      error: ""
    };
  },
  methods: {
    querySubmit: function() {
      this.getOrderData()
    },
    getData: function() {
      this.http.post(
        '/home/order/processing', 
        this.form, res => {
          if (res.success) {
            // 返回正确的处理
            this.noOver = res.datas.data

          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    getCurrentMonthFirst () {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10)  month = '0' + month
      if (day < 10)  day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
  },
  mounted: function() {
    console.log("初始化..........")
    const end= new Date()
    const start = new Date(this.getCurrentMonthFirst ())
    this.form.startDateStr = [start, end]
    this.getData()
  }
};
</script>


<style>
.condition-css {
  margin-top: 6px;
  padding: 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.report-css {
  border: 1px solid #eee;
}
.box-css {
  margin-top: 6px;
  display: flex;
  padding: 15px 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.box-other {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 14%;
  margin: 0 30px 0 40px;
  border-radius: 4px 4px 4px 4px!important;
  padding: 10px 20px;
  background: #F2F6FC;
}
.box-lite {
  color: #9a9a9a;
}
</style>


// WEBPACK FOOTER //
// src/components/views/home/tdlDetail.vue